import { Condition, RemoteConfig } from '@ca/common/types'
import validateCondition, { ValidationResult } from './validateCondition'
import { Refraction } from '@ca/common'
import { debugConditions } from './getDebugLog'
import { VariableValues } from './OrderVariables'

const buildValues = (orderValues: {
  values: VariableValues
  refraction?: Refraction | null
}) => {
  const { values, refraction } = orderValues
  return {
    ...values,
    ref: refraction ?? undefined,
  }
}

type CheckOptions = {
  skipRefraction?: boolean
}

export const validateOrderValues = (
  condition: Condition | undefined,
  values: {
    values: VariableValues
    refraction?: Refraction | null
  },
  config: RemoteConfig | null | undefined,
  options?: CheckOptions
) => {
  if (!config) {
    debugConditions.log('validateOrderValues: config is missing')
    return {
      result: false,
    } satisfies ValidationResult
  }
  if (!condition) {
    debugConditions.log('validateOrderValues: condition is missing')

    return {
      result: false,
    } satisfies ValidationResult
  }
  if (!options?.skipRefraction && !values.refraction) {
    debugConditions.log('validateOrderValues: refraction is missing')

    return {
      result: true,
      errorKey: condition.errorKey,
    } satisfies ValidationResult
  }

  return validateCondition(condition, buildValues(values), config.conditions)
}

const checkOrderValues = (
  condition: Condition | undefined,
  values: {
    values: VariableValues
    refraction?: Refraction | null
  },
  config?: RemoteConfig | null,
  options?: CheckOptions
) => {
  return validateOrderValues(condition, values, config, options)?.result
}

export default checkOrderValues
